import { render, staticRenderFns } from "./narcoticTable.vue?vue&type=template&id=56305e5a"
import script from "./narcoticTable.vue?vue&type=script&lang=js"
export * from "./narcoticTable.vue?vue&type=script&lang=js"
import style0 from "./narcoticTable.vue?vue&type=style&index=0&id=56305e5a&prod&lang=css"
import style1 from "./narcoticTable.vue?vue&type=style&index=1&id=56305e5a&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports